<div fxLayout="row" style="margin-bottom: 20px;">
    <button mat-raised-button (click)="back()" class="margin-r">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <mat-card-title class="margin-r">{{ title }}</mat-card-title>
    <!-- <button *ngIf="tokenStorageService.isAdminKepegawaian() || tokenStorageService.isSuperadmin()" mat-raised-button
        color="primary" (click)="openDialog({ typeId: this.type, title: this.title })" class="margin-r">
        Tambah Data
    </button> -->
    <button *ngIf="tokenStorageService.isAdminKepegawaian() || tokenStorageService.isSuperadmin()" mat-raised-button
        color="primary" class="margin-r" (click)="openDialog({ typeId: this.type, title: this.title })">
        Pengajuan Baru
    </button>
</div>

<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

<mat-card *ngIf="datas.length === 0">
    <mat-card-content>
        <div class="center-col">Tidak ada data</div>
    </mat-card-content>
</mat-card>

<mat-card *ngFor="let item of datas" [value]="item">
    <mat-card-content (click)="openDialog(item, title)" class="cursor-pointer">
        <div fxLayout="row wrap">
            <div fxFlex.gt-lg="70" fxFlex.gt-md="70" fxFlex.gt-xs="100" fxFlex="100">
                <div *ngIf="this.type === ProfileType.GOLONGAN">
                    {{ getPrefixLabel(item) }}{{ item.golongan?.code }} {{ item.golongan?.name }}
                </div>
                <div *ngIf="this.type === ProfileType.PENDIDIKAN">
                    {{ getPrefixLabel(item) }}{{ item.name }}
                </div>
                <div *ngIf="this.type === ProfileType.JABATAN">
                    {{ getPrefixLabel(item) }}{{ item.jabatan?.name }}
                </div>
                <div *ngIf="this.type === ProfileType.SKP">
                    {{ getPrefixLabel(item) }}Nilai SKP: {{ item.nilaiSkp }} Tahun: {{ item.tahun }}
                </div>
                <div *ngIf="this.type === ProfileType.PNS">
                    {{ getPrefixLabel(item) }}{{ item.userFullname }}
                </div>
                <div *ngIf="this.type === ProfileType.KGB">
                    {{ getPrefixLabel(item) }}TMT: {{ item.tmt }} KGB: {{ item.tmt2 }}
                </div>
                <div *ngIf="this.type === ProfileType.BUP">
                    {{ getPrefixLabel(item) }}{{ item.tmt2 }}
                </div>
                <div *ngIf="this.type === ProfileType.PENGHARGAAN">
                    {{ getPrefixLabel(item) }}{{ item.penghargaan.name }}
                </div>
                <div *ngIf="this.type === ProfileType.SATYA_LENCANA">
                    {{ getPrefixLabel(item) }} Satya Lencana {{ item.tahun2 }}th Tahun: {{ item.tahun }}
                </div>
                <div *ngIf="this.type === ProfileType.KELUARGA">
                    {{ getPrefixLabel(item) }}{{ item.hubungan?.name }}: {{ item.name }}
                </div>
                <div *ngIf="this.type === ProfileType.KARIS_KARSU">
                    {{ getPrefixLabel(item) }}{{ item.nomor }} - {{ item.name }}
                </div>
            </div>

            <div fxFlex.gt-lg="30" fxFlex.gt-md="30" fxFlex.gt-xs="100" fxFlex="100">
                <button mat-icon-button matTooltip="Status" matTooltipPosition="above"
                    (click)="navigateToProgress(item)">
                    <mat-icon>playlist_add_check</mat-icon>
                </button>
                <button *ngIf="tokenStorageService.isAdminKepegawaian() || tokenStorageService.isSuperadmin()"
                    mat-icon-button matTooltip="Ubah" matTooltipPosition="above" (click)="openDialog(item, title)">
                    <mat-icon>edit</mat-icon>
                </button>
                <button *ngIf="tokenStorageService.isAdminKepegawaian() || tokenStorageService.isSuperadmin()"
                    mat-icon-button matTooltip="Hapus" matTooltipPosition="above" (click)="confirmDialog(item)">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>